import { PayAllProductListResponse } from '@/modules/services/payAll/services/apiValidation/payAllProductApiValidationSchema.ts'
import { PayAllServiceListResponse } from '@/modules/services/payAll/services/apiValidation/payAllServiceApiValidationSchema.ts'
import { DailyCutCashoutListResponse } from '@/modules/services/dailyCut/services/apiValidation/dailyCutCashOutApiValidationSchema.ts'
import { DailyCutCashOutDetailsListResponse } from '@/modules/services/dailyCut/services/apiValidation/dailyCutCashOutDetailApiValidationSchema.ts'

export const payAllProductsPage: { data: PayAllProductListResponse } = {
  data: {
    results: [
      {
        id: '1',
        name: 'Movistar',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/movistar.png',
        isActive: true
      },
      {
        id: '2',
        name: 'Digitel',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/digitel.png',
        isActive: true
      },
      {
        id: '3',
        name: 'Movilnet',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/movilnet.png',
        isActive: true
      },
      {
        id: '4',
        name: 'Inter',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/inter.png',
        isActive: true
      },
      {
        id: '5',
        name: 'Cantv',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/cantv.png',
        isActive: false
      },
      {
        id: '6',
        name: 'SimpleTV',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/simpletv.png',
        isActive: false
      },
      {
        id: '7',
        name: 'Netuno',
        imageUrl:
          'https://weppa2-prod-storages.s3.us-east-1.amazonaws.com/public/payall-logos/netuno.png',
        isActive: false
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 7,
      range: [1],
      count: 7,
      pages: 1,
      total: 7,
      limit: 20
    }
  }
}

export const payAllServicesPage: { data: PayAllServiceListResponse } = {
  data: {
    results: [
      {
        id: '1',
        name: 'Cantv Residencial',
        code: 58,
        isActive: true,
        accountId: null,
        accountNumber: '01020001000012345678',
        accountType: 'Ahorro',
        commission: '2.50',
        rif: 'J-123456789',
        beneficiary: 'Inversiones Tech C.A.'
      },
      {
        id: '9',
        name: 'Cantv TV Satelital',
        code: 59,
        isActive: true,
        accountId: null,
        accountNumber: null,
        accountType: null,
        commission: null,
        rif: null,
        beneficiary: null
      },
      {
        id: '10',
        name: 'Cantv Empresarial',
        code: 57,
        isActive: true,
        accountId: null,
        accountNumber: null,
        accountType: null,
        commission: null,
        rif: null,
        beneficiary: null
      },
      {
        id: '11',
        name: 'Cantv ABA Cantv',
        code: 56,
        isActive: true,
        accountId: null,
        accountNumber: null,
        accountType: null,
        commission: null,
        rif: null,
        beneficiary: null
      },
      {
        id: '12',
        name: 'Cantv ABA Ultra',
        code: 55,
        isActive: true,
        accountId: null,
        accountNumber: null,
        accountType: null,
        commission: null,
        rif: null,
        beneficiary: null
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 5,
      range: [1],
      count: 5,
      pages: 1,
      total: 5,
      limit: 20
    }
  }
}

export const dailyCutCashOutPage: { data: DailyCutCashoutListResponse } = {
  data: {
    results: [
      {
        id: '1',
        serviceCode: '001',
        serviceName: 'Serv-411',
        rechargesQuantity: 5,
        rechargesAmount: '250.00',
        serviceCommission: '3.00',
        rechargeCommission: '50.00',
        status: 'PENDIENTE',
        amountToPay: '12',
        cutDate: '19/03/2026'
      },
      {
        id: '2',
        serviceCode: '001',
        serviceName: 'Serv-404',
        rechargesQuantity: 5,
        rechargesAmount: '250.00',
        serviceCommission: '3.00',
        rechargeCommission: '50.00',
        status: 'PROCESADO',
        amountToPay: '12',
        cutDate: '19/03/2026'
      },
      {
        id: '3',
        serviceCode: '001',
        serviceName: 'Serv-500',
        rechargesQuantity: 5,
        rechargesAmount: '250.00',
        serviceCommission: '3.00',
        rechargeCommission: '50.00',
        status: 'ERROR',
        amountToPay: '12',
        cutDate: '19/03/2026'
      }
    ],
    total: {
      rechargesQuantity: 5,
      rechargesAmount: '250.00',
      serviceCommission: '3.00',
      rechargeCommission: '50.00'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const dailyCutCashOutDetailsPage: {
  data: DailyCutCashOutDetailsListResponse
} = {
  data: {
    results: [
      {
        id: '1ea96cc3-7bc9-4bcb-bb8f-071facad4a4e',
        serviceName: 'Movistar Prepago',
        amount: '0.43',
        clientName: null,
        clientNumber: null,
        createdAt: '23/02/2026',
        serviceCode: '01'
      },
      {
        id: '89a34e74-149b-4068-9cc6-c6aeccb1dd69',
        serviceName: 'Movistar Prepago',
        amount: '0.43',
        clientName: null,
        clientNumber: null,
        createdAt: '23/02/2026',
        serviceCode: '01'
      }
    ],
    total: {
      rechargesAmount: null
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}
